<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-23 17:38:14
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 11:17:40
-->
<template>
	<el-drawer :visible.sync="drawer" :wrapperClosable="false" :size="760" destroy-on-close :before-close="cancel" title="新建招商活动">
		<div class="pt-24 pr-30 pl-30 content">
			<division title="活动信息" required>
				<base-info-form ref="baseInfoForm"></base-info-form>
			</division>
			<division title="招商类目" subTitle="指定类目后，商家仅可提报选中类目的商品。" required class="mt-8">
				<category-form ref="categoryForm"></category-form>
			</division>
			<division title="合作定价" subTitle="请填写期望的佣金水平、服务费、本场招商效果预估。" required class="mt-8">
				<coop-price-form ref="priceForm"></coop-price-form>
			</division>
			<division title="联系方式" subTitle="选填，填写后商家可在活动信息中看到对应联系方式。" class="mt-8">
				<contact-form ref="contactForm"></contact-form>
			</division>
		</div>
		<footer class="footer">
			<span class="yx-color-text-primary fz-14">详情请了解<a class="link" target="_blank" :href="serviceUrl">《招商活动服务协议》</a></span>
			<div>
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" :disabled="canSubmit" @click="create">立即发布</el-button>
			</div>
		</footer>
	</el-drawer>
</template>
<script>
import Division from './components/division';
import BaseInfoForm from './components/baseInfoForm';
import CategoryForm from './components/categoryForm';
import CoopPriceForm from './components/coopPriceForm';
import ContactForm from './components/contactForm';
import { activityCreate } from '@/api/secondColonelManage';
import debounce from 'lodash/debounce';
export default {
	name: 'NewActivityDrawer',
	data() {
		return {
			drawer: false,
			serviceUrl: 'https://automan.jinritemai.com/docpage/views/f853dd52-c2e8-4ed4-a4a6-9ef4700210fd',
			formData: {},
			loading: false,
			requiredItem: {
				activity_type: 1,
				activity_name: '',
				activity_desc: '',
				apply_end_time: '',
				commission_rate: '',
				service_rate: '',
				ad_commission_rate: '',
				ad_service_rate: '',
				cos_limit_type: '0',
				estimated_single_sale: '',
				categories: '0',
			},
			authorityId: '',
		};
	},
	created() {
		this.$Bus.$on('requiredItemChange', val => {
			this.requiredItem = { ...this.requiredItem, ...val };
		});
	},
	computed: {
		canSubmit() {
			const {
				activity_type,
				// eslint-disable-next-line no-unused-vars
				specified_shop_ids,
				...rest
			} = this.requiredItem;
			
			// 全部商家时剔除指定商家判断
			const targetItems = activity_type === 2 ? { ...this.requiredItem } : { ...rest };
			// 仅限固定佣金商品时剔除投放期佣金率和服务费率判断
			if (this.requiredItem.cos_limit_type === '3') {
				delete targetItems.ad_commission_rate;
				delete targetItems.ad_service_rate;
			}
			// console.log('必填项', targetItems);
			const result = Object.values(targetItems).findIndex(item => item === '' || item === undefined) !== -1;
			return result;
		},
	},
	methods: {
		show(authorityId) {
			this.drawer = true;
			this.authorityId = authorityId;
		},
		validate() {
			return new Promise(async (resolve, reject) => {
				Promise.all([
					this.$refs.baseInfoForm.validate(),
					this.$refs.categoryForm.validate(),
					this.$refs.contactForm.validate(),
					this.$refs.priceForm.validate(),
				])
					.then(results => {
						let _formData = {};
						results.forEach(element => {
							_formData = Object.assign(_formData, element);
						});
						resolve(_formData);
					})
					.catch(() => {
						reject('校验不通过');
					});
			});
		},
		create: debounce(async function() {
			this.loading = true;
			try {
				this.formData = await this.validate();
				this.formData.authority_id = this.authorityId;
				
				if(this.formData.cos_limit_type == 3){
					delete this.formData.ad_commission_rate;
					delete this.formData.ad_service_rate;
				}
				console.log('提交的表单数据', this.formData);
				const { code } = await activityCreate({ ...this.formData });
				if (code === 0) {
					this.$message.success('招商活动创建成功');
					this.clear();
				}
				// 刷新外部列表
				this.$emit('refresh');
			} catch (error) {
				this.loading = false;
			}
		}, 500),
		cancel() {
			const isModified = [
				this.$refs.baseInfoForm.isFormModified(),
				this.$refs.categoryForm.isFormModified(),
				this.$refs.priceForm.isFormModified(),
				this.$refs.contactForm.isFormModified(),
			].includes(true);
			// 没有改动就直接隐藏
			if (!isModified) {
				this.drawer = false;
				return;
			}
			// 有改动进行提示
			isModified &&
				this.$confirm('取消后，将不会保存您填写的活动信息, 是否确认取消?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						this.drawer = false;
						this.clear();
					})
					.catch(_ => {});
		},
		clear() {
			this.formData = {};
			this.loading = false;
			this.requiredItem = {
				activity_type: 1,
				activity_name: '',
				activity_desc: '',
				apply_end_time: '',
				commission_rate: '',
				service_rate: '',
				ad_commission_rate: '',
				ad_service_rate: '',
				cos_limit_type: '0',
				estimated_single_sale: '',
				categories: '0',
			};
			this.authorityId = '';
			this.drawer = false;
		},
	},
	components: {
		Division,
		BaseInfoForm,
		CategoryForm,
		CoopPriceForm,
		ContactForm,
	},
	beforeDestroy() {
		this.$Bus.$off('requiredItemChange');
	},
};
</script>
<style lang="less" scoped>
.footer {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px;
	border-top: 1px solid @background-color-base;
	background-color: #fff;
	.link {
		color: @color-primary;
	}
}
.content {
	padding-bottom: 65px;
}
</style>
